const fileSizeErrorTemplate = 'The file could not be uploaded. The file must be less than';

export const INVALID_FILE_TYPE_ERROR =
    'The file could not be uploaded. The file must have one of the following extensions: BMP, GIF, JPEG, JPG, PNG, or PDF.';

export const FILE_SIZE_GREATER_60MB_ERROR = `${fileSizeErrorTemplate} 60MB.`;

export const FILE_IS_CORRUPTED_ERROR =
    'There was an error with your file. Please try again or choose another file to upload.';

export const MAX_FILE_SIZE_BYTES = 1000 * 1000 * 60;
